import React, { useCallback } from 'react';
import { Select } from 'modules/filters/utils';
import { injectIntl } from 'react-intl';

const VehicleTypeFilter = ({ value, onChange, className, intl }) => {
  const t = intl.messages.modules.Filters.vehicle_type;
  const vo = intl.messages.modules.Filters.vehicle_type.vehicle_options;
  const vehiclesOptions = [
    { label: vo.van_label, value: vo.van },
    { label: vo.box_van_label, value: vo.box_van },
    { label: vo.rigid_truck_label, value: vo.rigid_truck },
    { label: vo.trailer_label, value: vo.trailer },
  ];
  const handleChange = useCallback(
    (change) => {
      onChange(change);
    },
    [onChange]
  );

  return (
    <div className={className} data-testid="vehicle_type_filter">
      <Select
        value={value}
        isMulti
        options={vehiclesOptions}
        onChange={handleChange}
        placeholder={t.placeholder}
        closeMenuOnSelect={false}
      />
    </div>
  );
};

export default injectIntl(VehicleTypeFilter);
